module.exports = __webpack_public_path__ + "static/media/3DPPA22.68fb27ad.jpg";